import CircularProgress from '@mui/material/CircularProgress'
import classnames from 'classnames'
import {ButtonMin} from 'component/ButtonMin'
import {SignatureCanvasPopoutComponent} from 'component/SignatureCanvasPopout'
import React, {Fragment, useCallback, useState} from 'react'
import FontAwesome from "react-fontawesome"
import {base64ToDataURI} from 'util/FileReaderUtil'
import './SignatureComponent.css'
import {CFComponentLazyProps} from 'module/CustomField/type/CFComponentType';

export function SignatureComponent(props: CFComponentLazyProps) {
	let {loading, disabled, mimeType, data, preview, setCb, removeCb, resetCb, hasData} = props;
	const [editing, setEditing] = useState(false);
	const startEditing = useCallback(() => !disabled && setEditing(true), [disabled, setEditing]);
	const doneEditing = useCallback(() => setEditing(false), [setEditing]);
	const clearValue = useCallback(() => !disabled && removeCb?.(), [disabled, removeCb]);
	const resetValue = useCallback(() => resetCb?.(), [disabled, resetCb]);
	const src = base64ToDataURI(mimeType, data) || preview;
	return (
		<Fragment>
			<table className={'SignatureComponent'}>
				<tbody>
				<tr>
					<td className={'SignatureComponentDataSection'}>
						{
							loading &&
							<CircularProgress/>
							||
							<div className={'SignatureComponentPreviewRegion'} onClick={startEditing}>
								{
									hasData &&
									<img src={src} alt=""/>
								}
								<div className={classnames('SignatureComponentEditInfo', {hasData})}>
									{
										<Fragment>
											{
												!hasData &&
												<div className={'SignatureComponentNoData'}>Keine Daten vorhanden</div>
											}
											{!disabled &&
												<div>
													<FontAwesome name={'edit'}/>
													&nbsp;
													Klicken um zu unterschreiben
												</div>
											}
										</Fragment>
									}
								</div>
							</div>
						}
					</td>
					{
						!disabled &&
						<td className={'SignatureComponentButtonRegion'}>
							{
								!disabled &&
								<div>
									<ButtonMin onClick={startEditing}>
										<FontAwesome name={'edit'}/>
									</ButtonMin>
								</div>
							}
							{
								resetCb &&
								<div>
									<ButtonMin onClick={resetValue}>
										<FontAwesome name={'undo'}/>
									</ButtonMin>
								</div>
							}
							{
								hasData &&
								<div>
									<ButtonMin onClick={clearValue}>
										<FontAwesome name={'times'}/>
									</ButtonMin>
								</div>
							}
						</td>
					}
				</tr>
				</tbody>
			</table>
			<SignatureCanvasPopoutComponent
				open={!disabled && editing}
				onChange={setCb}
				handleClose={doneEditing}
			/>
		</Fragment>
	)
}